import { CoreText } from './Core/CoreText';
import { withStyles } from './Core/withStyles';

export const ThemeText = withStyles(CoreText, {type: 'ThemeText'});